import { oc } from '@orpc/contract';
import { runDetailSchema, updateRunConditionsInputSchema } from '../schemas/runs.schemas.js';
export const updateRunConditionsContract = oc
    .route({
    method: 'PATCH',
    path: '/runs/{id}/conditions',
    tags: ['Runs'],
    summary: 'Fill in the pre-test checklist of a draft run',
    description: 'Only while the run is DRAFT. An absent field is left alone; an explicit null clears it.',
})
    .input(updateRunConditionsInputSchema)
    .output(runDetailSchema);
//# sourceMappingURL=update-run-conditions.contract.js.map